var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_34445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.625 367.735H851.381V550.1L778.138 477.895L671.716 545.471L564.041 477.894L470.765 606.568L369.976 649.152L325.529 594.534L290.472 515.848L257.293 563.06L183.423 471.414L132.09 482.522L74.497 409.391L0 381.62L0.625 367.735Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.681 387.72H591.462V353.449H579.875C578.826 353.163 578.267 352.621 578.049 351.625V332.894C578.191 332.501 578.443 332.163 578.923 332.022H591.494L591.384 302.418H577.89V295.195H568.049L568.091 263.797L576.181 263.811L576.223 257.496H543.92V263.845H552.096V295.354H532.175V302.529H518.625V331.937H531.252C531.778 332.064 532.075 332.391 532.178 332.863V351.748C531.955 352.72 531.276 353.406 530.312 353.614H518.681V387.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.02 316.267V310.909L532.553 309.937L532.612 295.789L552.534 295.809V263.407H544.338L544.357 257.951L575.772 257.941L575.751 263.378L567.649 263.35L567.607 295.64L577.439 295.635L577.496 309.775L581.38 310.434L581.538 316.465L529.02 316.267Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.911 347.204H539.483V753.074H570.911V347.204Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.013 747.795C557.013 748.663 556.159 749.366 555.105 749.366C554.051 749.366 553.197 748.663 553.197 747.795C553.197 746.927 554.051 746.224 555.105 746.224C556.159 746.223 557.013 746.926 557.013 747.795Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.727 743.196H552.952V745.89H563.727V743.196Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.625 615.689H555.646V626.464H564.625V615.689Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.982 664.174C548.015 664.012 547.44 664.295 545.339 661.143V503.33H548.594V659.572L553.645 660.582L553.982 664.174Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.389 657.559L552.333 654.407L549.24 652.508V625.522H567.255V652.587L564.093 654.446L564.13 657.6L552.389 657.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.08 657.031V659.491L554.873 666.634H565.51V660.682H567.176V657.031H549.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 723.101C568.125 724.155 567.698 725.011 567.172 725.013C566.644 725.015 566.217 724.163 566.217 723.108C566.217 723.106 566.217 723.104 566.217 723.101C566.215 722.047 566.642 721.191 567.17 721.189C567.696 721.187 568.124 722.039 568.125 723.093C568.125 723.096 568.125 723.101 568.125 723.101Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 715.02C568.125 716.074 567.698 716.93 567.172 716.932C566.644 716.934 566.217 716.082 566.217 715.027C566.217 715.025 566.217 715.023 566.217 715.02C566.215 713.966 566.642 713.11 567.17 713.108C567.696 713.106 568.124 713.958 568.125 715.012C568.125 715.014 568.125 715.018 568.125 715.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 706.489C568.125 707.543 567.698 708.399 567.172 708.401C566.644 708.403 566.217 707.551 566.217 706.497C566.217 706.495 566.217 706.493 566.217 706.49C566.215 705.436 566.642 704.58 567.17 704.578C567.696 704.576 568.124 705.428 568.125 706.482C568.125 706.484 568.125 706.489 568.125 706.489Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 698.183C568.125 699.237 567.698 700.093 567.172 700.095C566.644 700.097 566.217 699.245 566.217 698.191C566.217 698.189 566.217 698.187 566.217 698.184C566.215 697.13 566.642 696.274 567.17 696.272C567.696 696.27 568.124 697.122 568.125 698.177V698.183Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 689.99C568.125 691.044 567.698 691.9 567.172 691.902C566.644 691.904 566.217 691.052 566.217 689.998C566.217 689.996 566.217 689.994 566.217 689.991C566.215 688.937 566.642 688.081 567.17 688.079C567.696 688.077 568.124 688.929 568.125 689.984C568.125 689.984 568.125 689.988 568.125 689.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 682.02C568.125 683.074 567.698 683.93 567.172 683.932C566.644 683.934 566.217 683.082 566.217 682.028C566.217 682.026 566.217 682.024 566.217 682.021C566.215 680.967 566.642 680.111 567.17 680.109C567.696 680.107 568.124 680.959 568.125 682.014V682.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 724.811L555.906 730.208L560.429 730.287L567.255 724.811L567.415 665.84H549.239L549.238 724.811Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 739.489C568.125 740.543 567.698 741.399 567.172 741.401C566.644 741.403 566.217 740.551 566.217 739.496C566.217 739.494 566.217 739.492 566.217 739.489C566.215 738.435 566.642 737.579 567.17 737.577C567.696 737.575 568.124 738.427 568.125 739.482C568.125 739.482 568.125 739.487 568.125 739.489Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 731.295C568.125 732.349 567.698 733.205 567.172 733.207C566.644 733.209 566.217 732.357 566.217 731.302C566.217 731.3 566.217 731.298 566.217 731.295C566.215 730.241 566.642 729.385 567.17 729.383C567.696 729.381 568.124 730.233 568.125 731.287C568.125 731.29 568.125 731.293 568.125 731.295Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.422 729.727H550.259V743.196H566.422V729.727Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.625 527.69H555.646V540.261H564.625V527.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.32 540.262H549.361V616.587H567.32V540.262Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.523 511.527H554.748V528.588H565.523V511.527Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.523 503.446H554.748V509.732H565.523V503.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.319 508.834H552.952V512.426H567.319V508.834Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.217 497.16H542.177V504.344H568.217V497.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.523 462.141H554.748V468.427H565.523V462.141Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.891 447.097C544.987 445.984 544.805 444.243 545.901 443.281C547.638 441.989 548.674 441.054 549.38 438.791V397.71C549.194 395.432 547.682 393.227 545.746 391.912L546.462 388.618H549.156L549.703 391.818C551.444 393.435 552.266 395.187 552.467 397.577L552.579 439.013C551.466 442.842 549.92 444.231 548.343 446.347L544.891 447.097Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.983 445.08H549.248C549.806 445.08 550.258 445.433 550.258 445.866V468.539C550.258 468.972 549.805 469.325 549.248 469.325H544.983C544.425 469.325 543.973 468.972 543.973 468.539V445.866C543.973 445.432 544.425 445.08 544.983 445.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.319 468.426H543.075V479.201H567.319V468.426Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.115 479.202H541.279V496.263H569.115V479.202Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.523 374.142H554.748V455.855H565.523V374.142Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.421 454.957H553.85V462.141H566.421V454.957Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.38 319.368H526.014V322.96H584.38V319.368Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.595 347.256V323.068L541.187 319.476H569.018L572.559 323.012V347.256L570.735 349.08H539.391L537.595 347.256Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.602 316.702H591.462H518.602Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.602 316.702H591.462",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.625 254.716H555.646V369.653H564.625V254.716Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.421 368.755H553.85V375.041H566.421V368.755Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 743.642C548.931 744.634 548.328 745.438 547.584 745.438C546.839 745.438 546.237 744.634 546.237 743.642C546.237 742.651 546.839 741.846 547.584 741.846C548.328 741.846 548.931 742.65 548.931 743.642Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 735.56C548.931 736.552 548.328 737.356 547.584 737.356C546.839 737.356 546.237 736.552 546.237 735.56C546.237 734.569 546.839 733.764 547.584 733.764C548.328 733.764 548.931 734.569 548.931 735.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 727.591C548.931 728.583 548.328 729.387 547.584 729.387C546.839 729.387 546.237 728.583 546.237 727.591C546.237 726.6 546.839 725.795 547.584 725.795C548.328 725.795 548.931 726.6 548.931 727.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 718.948C548.931 719.94 548.328 720.744 547.584 720.744C546.839 720.744 546.237 719.94 546.237 718.948C546.237 717.957 546.839 717.152 547.584 717.152C548.328 717.152 548.931 717.957 548.931 718.948Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 710.867C548.931 711.859 548.328 712.663 547.584 712.663C546.839 712.663 546.237 711.859 546.237 710.867C546.237 709.876 546.839 709.071 547.584 709.071C548.328 709.071 548.931 709.876 548.931 710.867Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 702.561C548.931 703.553 548.328 704.357 547.584 704.357C546.839 704.357 546.237 703.553 546.237 702.561C546.237 701.57 546.839 700.765 547.584 700.765C548.328 700.765 548.931 701.57 548.931 702.561Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 694.367C548.931 695.359 548.328 696.163 547.584 696.163C546.839 696.163 546.237 695.359 546.237 694.367C546.237 693.376 546.839 692.571 547.584 692.571C548.328 692.571 548.931 693.376 548.931 694.367Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.931 686.173C548.931 687.165 548.328 687.969 547.584 687.969C546.839 687.969 546.237 687.165 546.237 686.173C546.237 685.182 546.839 684.377 547.584 684.377C548.328 684.378 548.931 685.182 548.931 686.173Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 747.57C543.656 748.685 543.255 749.592 542.76 749.594C542.263 749.598 541.86 748.694 541.86 747.579C541.86 747.575 541.86 747.574 541.86 747.57C541.858 746.455 542.26 745.548 542.756 745.546C543.251 745.544 543.654 746.446 543.656 747.563C543.656 747.565 543.656 747.568 543.656 747.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 739.152C543.656 740.267 543.255 741.174 542.76 741.176C542.263 741.18 541.86 740.276 541.86 739.161C541.86 739.157 541.86 739.156 541.86 739.152C541.858 738.037 542.26 737.13 542.756 737.128C543.251 737.126 543.654 738.028 543.656 739.145C543.656 739.147 543.656 739.15 543.656 739.152Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 731.407C543.656 732.522 543.255 733.429 542.76 733.431C542.263 733.435 541.86 732.531 541.86 731.416C541.86 731.412 541.86 731.411 541.86 731.407C541.858 730.292 542.26 729.385 542.756 729.383C543.251 729.381 543.654 730.283 543.656 731.4C543.656 731.402 543.656 731.405 543.656 731.407Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 723.214C543.656 724.329 543.255 725.236 542.76 725.238C542.263 725.242 541.86 724.338 541.86 723.223C541.86 723.219 541.86 723.218 541.86 723.214C541.858 722.099 542.26 721.192 542.756 721.19C543.251 721.188 543.654 722.09 543.656 723.207C543.656 723.207 543.656 723.212 543.656 723.214Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 714.459C543.656 715.574 543.255 716.481 542.76 716.483C542.263 716.487 541.86 715.583 541.86 714.468C541.86 714.464 541.86 714.463 541.86 714.459C541.858 713.344 542.26 712.437 542.756 712.435C543.251 712.433 543.654 713.335 543.656 714.452C543.656 714.452 543.656 714.457 543.656 714.459Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 706.489C543.656 707.604 543.255 708.511 542.76 708.513C542.263 708.517 541.86 707.613 541.86 706.498C541.86 706.494 541.86 706.493 541.86 706.489C541.858 705.374 542.26 704.467 542.756 704.465C543.251 704.463 543.654 705.365 543.656 706.482C543.656 706.484 543.656 706.489 543.656 706.489Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 698.52C543.656 699.635 543.255 700.542 542.76 700.544C542.263 700.548 541.86 699.644 541.86 698.529C541.86 698.525 541.86 698.524 541.86 698.52C541.858 697.405 542.26 696.498 542.756 696.496C543.251 696.494 543.654 697.396 543.656 698.513C543.656 698.515 543.656 698.518 543.656 698.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 689.877C543.656 690.992 543.255 691.899 542.76 691.901C542.263 691.905 541.86 691.001 541.86 689.886C541.86 689.882 541.86 689.881 541.86 689.877C541.858 688.762 542.26 687.855 542.756 687.853C543.251 687.851 543.654 688.753 543.656 689.87C543.656 689.872 543.656 689.877 543.656 689.877Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.656 681.684C543.656 682.799 543.255 683.706 542.76 683.708C542.263 683.712 541.86 682.808 541.86 681.693C541.86 681.689 541.86 681.688 541.86 681.684C541.858 680.569 542.26 679.662 542.756 679.66C543.251 679.658 543.654 680.56 543.656 681.677C543.656 681.677 543.656 681.682 543.656 681.684Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.125 747.346C568.125 748.4 567.698 749.256 567.172 749.258C566.644 749.26 566.217 748.408 566.217 747.354C566.217 747.352 566.217 747.35 566.217 747.347C566.215 746.293 566.642 745.437 567.17 745.435C567.696 745.433 568.124 746.285 568.125 747.34C568.125 747.34 568.125 747.344 568.125 747.346Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.983 553.731H567.207C567.765 553.731 568.217 554.084 568.217 554.517V557.435C568.217 557.868 567.764 558.221 567.207 558.221H544.983C544.425 558.221 543.973 557.868 543.973 557.435V554.517C543.973 554.083 544.425 553.731 544.983 553.731Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.983 594.138H567.207C567.765 594.138 568.217 594.491 568.217 594.924V597.842C568.217 598.275 567.764 598.628 567.207 598.628H544.983C544.425 598.628 543.973 598.275 543.973 597.842V594.924C543.973 594.49 544.425 594.138 544.983 594.138Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.983 637.239H567.207C567.765 637.239 568.217 637.592 568.217 638.025V640.943C568.217 641.378 567.764 641.729 567.207 641.729H544.983C544.425 641.729 543.973 641.378 543.973 640.943V638.025C543.973 637.591 544.425 637.239 544.983 637.239Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.289 489.977H568.105C568.663 489.977 569.115 490.33 569.115 490.763V491.885C569.115 492.318 568.662 492.671 568.105 492.671H542.289C541.731 492.671 541.279 492.318 541.279 491.885V490.763C541.279 490.329 541.732 489.977 542.289 489.977Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.575 430.713H566.309C566.867 430.713 567.319 431.066 567.319 431.499V433.519C567.319 433.952 566.866 434.305 566.309 434.305H548.575C548.017 434.305 547.565 433.952 547.565 433.519V431.499C547.565 431.065 548.017 430.713 548.575 430.713Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.575 401.081H566.309C566.867 401.081 567.319 401.434 567.319 401.867V403.887C567.319 404.32 566.866 404.673 566.309 404.673H548.575C548.017 404.673 547.565 404.32 547.565 403.887V401.867C547.565 401.433 548.017 401.081 548.575 401.081Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.054 380.428H543.075V389.407H552.054V380.428Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.259 389.407H543.973V392.101H550.259V389.407Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.361 371.449H543.973V380.428H549.361V371.449Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.054 366.959H543.075V371.449H552.054V366.959Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.361 330.143H543.973V366.959H549.361V330.143Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.259 283.45H543.973V302.307H550.259V283.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.156 300.511H542.177V330.143H551.156V300.511Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.808 279.055L463.588 279.017C459.994 278.988 454.882 283.072 454.951 287.654V308.052H452.094L452.054 287.574C452.089 281.623 457.359 276.359 463.527 276.378L524.836 276.337L524.808 279.055Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.912 275.369H524.218V280.757H526.912V275.369Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.279 274.471H526.014V281.655H541.279V274.471Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.975 284.376C542.993 283.326 542.189 282.307 541.158 282.338L541.209 273.191L543.526 273.196C548.298 273.263 551.527 277.711 551.484 282.358V284.43L542.975 284.376Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.186 337.754V335.909H526.798V337.795L523.186 337.754Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.432 332.283V335.976L522.274 336.818H527.662L528.56 335.92V332.273L521.432 332.283Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.441 337.93V336.083H587.052V337.969L583.441 337.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.685 332.458V336.151L582.527 336.993H587.915L588.813 336.095V332.448L581.685 332.458Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.423 296.382V298.227H587.034V296.342L583.423 296.382Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.668 301.873V298.18L582.51 297.338H587.898L588.796 298.236V301.883L581.668 301.873Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.143 296.481V298.326H526.754V296.441L523.143 296.481Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.388 301.953V298.26L522.23 297.418H527.618L528.516 298.316V301.963L521.388 301.953Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.585 329.245H537.687V331.041H538.585V329.245Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.585 332.837H537.687V334.633H538.585V332.837Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.707 332.837H571.809V334.633H572.707V332.837Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.707 329.245H571.809V331.041H572.707V329.245Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.513 266.165V268.03L550.084 268.02L550.095 266.185L546.513 266.165Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.639 264.38V267.118H550.957V264.38H545.639Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.614 266.066V267.931L570.041 267.92L570.032 266.085L573.614 266.066Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.488 264.28V267.019H569.17V264.28H574.488Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.157 257.41H550.259V258.308H551.157V257.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.217 257.41H567.319V258.308H568.217V257.41Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.151 302.36V309.599L528.589 310.553V316.839",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.151 302.36V309.599L528.589 310.553V316.839",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.903 302.416L577.945 309.431L581.548 310.397V316.727",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.903 302.416L577.945 309.431L581.548 310.397V316.727",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.887 315.413L534.859 318.123L534.887 315.413Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.887 315.413L534.859 318.123",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.281 315.425V318.113V315.425Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.281 315.425V318.113",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.461 318.47H582.584V323.858H592.461V318.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.81 318.47H517.933V323.858H527.81V318.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.239 320.266H509.851V322.062H515.239V320.266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.807 324.864H515.08L514.152 323.935V318.608L515.096 317.663H517.775L517.807 324.864Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.544 320.266H595.156V322.062H600.544V320.266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.329 324.866H595.054L595.983 323.937V318.61L595.038 317.664H592.304L592.329 324.866Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.401 251.124H544.871V256.512H575.401V251.124Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.217 231.37H552.054V251.125H568.217V231.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.627 248.895V247.03L549.2 247.041L549.211 248.876L545.627 248.895Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.755 250.681V247.942H550.073V250.681H544.755Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.379 248.895V247.03L570.806 247.041L570.797 248.876L574.379 248.895Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.252 250.681V247.942H569.934V250.681H575.252Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.28 248.895V247.03L562.709 247.041L562.698 248.876L566.28 248.895Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.153 250.681V247.942H561.835V250.681H567.153Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.726 248.88V247.015L557.299 247.025L557.308 248.86L553.726 248.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.854 250.665V247.927H558.172V250.665H552.854Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.676 233.698V235.563L549.249 235.553L549.26 233.718L545.676 233.698Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.804 231.913V234.651H550.122V231.913H544.804Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.428 233.698V235.563L570.855 235.553L570.846 233.718L574.428 233.698Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.301 231.913V234.651H569.983V231.913H575.301Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.329 233.698V235.563L562.758 235.553L562.747 233.718L566.329 233.698Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.203 231.913V234.651H561.885V231.913H567.203Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.775 233.714V235.579L557.348 235.569L557.357 233.734L553.775 233.714Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.904 231.928V234.666H558.222V231.928H552.904Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.401 225.084H544.871V231.37H575.401V225.084Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.401 193.656H544.871V199.942H575.401V193.656Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.401 200.84H544.871V224.186H575.401V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.62 191.496V189.631L549.191 189.641L549.202 191.476L545.62 191.496Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.747 193.281V190.543H550.065V193.281H544.747Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.37 191.496V189.631L570.799 189.641L570.788 191.476L574.37 191.496Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.244 193.281V190.543H569.926V193.281H575.244Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.217 185.575H552.054V193.656H568.217V185.575Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.271 191.496V189.631L562.7 189.641L562.689 191.476L566.271 191.496Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.144 193.281V190.543H561.826V193.281H567.144Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.719 191.479V189.614L557.29 189.624L557.301 191.459L553.719 191.479Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.845 193.266V190.527H558.163V193.266H552.845Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.904 185.681L549.242 183.885V170.382L570.796 170.413V183.916L568.041 185.743L551.904 185.681Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.259 180.386L545.603 176.729V171.232L546.512 170.323H549.173L549.259 180.386Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.81 180.298L574.4 176.662V171.318L573.46 170.376H570.766L570.81 180.298Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.293 168.586V159.605H562.682V162.362H564.539V165.893H562.712V168.588L557.293 168.586Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.523 168.514H554.748V170.31H565.523V168.514Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.99 181.262L558.194 179.335V170.4H561.786V179.335L559.99 181.262Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.533 162.687L566.297 162.679L566.313 160.89L567.172 159.999H568.101L568.999 160.875L569.008 167.154L568.126 168.075H567.189L566.314 167.115L566.298 165.388L564.541 165.419L564.533 162.687Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.943 152.884C565.943 156.134 563.308 158.768 560.059 158.768C556.809 158.768 554.175 156.133 554.175 152.884C554.175 149.634 556.81 147 560.059 147C563.308 147 565.943 149.635 565.943 152.884Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.075 152.899L562.769 154.68L560.075 152.899Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.075 152.899L562.769 154.68",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.571 152.869C560.571 153.134 560.355 153.348 560.091 153.348C559.827 153.348 559.611 153.133 559.611 152.869C559.611 152.604 559.826 152.389 560.091 152.389C560.356 152.389 560.571 152.603 560.571 152.869Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.034 212.513H560.136V213.411H561.034V212.513Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.4 205.329H581.686V220.594H619.4V205.329Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.585 200.84H576.299V225.084H582.585V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.176 201.738H584.38V204.432H586.176V201.738Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.278 200.84H583.482V205.33H585.278V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.176 208.023H584.38V210.717H586.176V208.023Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.38 207.125H582.584V211.615H584.38V207.125Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.176 215.207H584.38V217.901H586.176V215.207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.38 214.309H582.584V218.799H584.38V214.309Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.176 221.492H584.38V224.186H586.176V221.492Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.38 220.594H582.584V225.084H584.38V220.594Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.788 200.84H618.502V225.084H624.788V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.706 201.738H614.91V204.432H616.706V201.738Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.604 200.84H615.808V205.33H617.604V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.706 208.023H614.91V210.717H616.706V208.023Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.604 207.125H615.808V211.615H617.604V207.125Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.706 215.207H614.91V217.901H616.706V215.207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.604 214.309H615.808V218.799H617.604V214.309Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.706 221.492H614.91V224.186H616.706V221.492Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.604 220.594H615.808V225.084H617.604V220.594Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.972 200.84H625.686V225.084H631.972V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.828 226.88H644.542V234.064H650.828V226.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.907 201.83V225.194C644.402 229.69 650.742 229.673 655.225 225.194L655.244 201.83H639.907Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.82 220.628H639.875C643.398 215.46 643.309 210.384 639.875 205.429H631.82V220.628Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.563 201.738H633.767V204.432H635.563V201.738Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.767 200.84H631.971V205.33H633.767V200.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.563 208.023H633.767V210.717H635.563V208.023Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.767 207.125H631.971V211.615H633.767V207.125Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.563 215.207H633.767V217.901H635.563V215.207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.767 214.309H631.971V218.799H633.767V214.309Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.563 221.492H633.767V224.186H635.563V221.492Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.767 220.594H631.971V225.084H633.767V220.594Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.011 213.049C613.002 219.756 607.557 225.185 600.85 225.176C594.158 225.167 588.733 219.743 588.724 213.049C588.715 206.342 594.143 200.898 600.85 200.889C607.557 200.88 613.002 206.309 613.011 213.016C613.011 213.026 613.011 213.037 613.011 213.049Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.081 216.462C594.085 217.513 593.236 218.369 592.184 218.374C591.132 218.378 590.276 217.528 590.272 216.476C590.272 216.472 590.272 216.467 590.272 216.463C590.268 215.411 591.119 214.555 592.169 214.551C593.221 214.547 594.077 215.397 594.081 216.449C594.081 216.453 594.081 216.458 594.081 216.462Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.141 209.577C594.145 210.629 593.296 211.485 592.244 211.489C591.192 211.493 590.336 210.643 590.332 209.591C590.332 209.586 590.332 209.582 590.332 209.578C590.328 208.526 591.179 207.67 592.229 207.666C593.281 207.662 594.137 208.512 594.141 209.564C594.141 209.568 594.141 209.572 594.141 209.577Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.027 204.488C599.031 205.54 598.18 206.396 597.128 206.4C596.077 206.404 595.222 205.554 595.216 204.503C595.216 204.498 595.216 204.494 595.216 204.489C595.212 203.438 596.063 202.582 597.115 202.578C598.167 202.573 599.023 203.424 599.027 204.475C599.027 204.479 599.027 204.483 599.027 204.488Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.413 204.442C606.418 205.494 605.568 206.35 604.516 206.354C603.464 206.358 602.608 205.508 602.604 204.457C602.604 204.452 602.604 204.447 602.604 204.443C602.6 203.392 603.451 202.536 604.503 202.532C605.554 202.527 606.409 203.378 606.413 204.429C606.413 204.433 606.413 204.438 606.413 204.442Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.161 221.66C599.165 222.712 598.314 223.568 597.262 223.572C596.211 223.576 595.356 222.726 595.35 221.674C595.35 221.67 595.35 221.665 595.35 221.661C595.346 220.609 596.197 219.754 597.249 219.749C598.301 219.745 599.157 220.595 599.161 221.647C599.161 221.651 599.161 221.656 599.161 221.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.424 209.596C611.428 210.647 610.577 211.503 609.525 211.507C608.473 211.511 607.617 210.661 607.613 209.61C607.613 209.605 607.613 209.601 607.613 209.597C607.609 208.545 608.46 207.689 609.512 207.685C610.564 207.681 611.418 208.531 611.424 209.583C611.424 209.587 611.424 209.592 611.424 209.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.424 216.541C611.428 217.593 610.577 218.449 609.525 218.453C608.473 218.457 607.617 217.607 607.613 216.555C607.613 216.55 607.613 216.546 607.613 216.542C607.609 215.491 608.46 214.635 609.512 214.631C610.564 214.627 611.418 215.476 611.424 216.528C611.424 216.532 611.424 216.537 611.424 216.541Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.383 221.621C606.387 222.673 605.536 223.529 604.486 223.533C603.434 223.537 602.578 222.687 602.574 221.635C602.574 221.631 602.574 221.626 602.574 221.622C602.57 220.57 603.419 219.714 604.471 219.71C605.523 219.706 606.379 220.556 606.383 221.608C606.383 221.612 606.383 221.616 606.383 221.621Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.767 245L598.681 212.609C599.218 209.543 603.52 210.162 602.978 213.424L597.343 245.991C596.692 249.009 592.069 247.947 592.767 245Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.321 213.009C601.321 213.271 601.107 213.484 600.844 213.484C600.583 213.484 600.369 213.271 600.369 213.009C600.369 212.746 600.583 212.533 600.844 212.533C601.106 212.534 601.321 212.746 601.321 213.009Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.012 233.166H637.359V238.554H658.012V233.166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.004 196.421C636.772 197.383 636.84 201.872 639.004 202.731H656.107C658.302 201.84 658.326 197.351 656.107 196.421H639.004Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.93 170.31H646.338V175.698H649.93V170.31Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.782 196.421V176.659C644.388 174.432 650.653 174.419 653.408 176.659V196.422L641.782 196.421Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.122 166.777C626.831 166.772 626.732 170.345 629.122 170.389H666.862C669.436 170.322 669.344 166.793 666.862 166.738L629.122 166.777Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.056 318.551V323.994V318.551Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.056 318.551V323.994",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.098 318.606V323.966V318.606Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.098 318.606V323.966",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.652 314.032H553.295H555.652Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.652 314.032H553.295",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.778 314.019H564.421H566.778Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.778 314.019H564.421",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.669 360.673H424.547V368.754H458.669V360.673Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.918 307.814V287.098C428.909 282.723 424.374 279.087 420.822 279.002H370.543V276.343H420.782C426.19 276.386 431.622 281.132 431.617 287.177V307.813L428.918 307.814Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.362 308.593H421.853V360.674H461.362V308.593Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.424 306.797H426.343V308.593H434.424V306.797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.77 306.797H449.689V308.593H457.77V306.797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67 272.675H367.976V282.552H370.67V272.675Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.589 361.571H293.447V367.857H362.589V361.571Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.977 249.328H288.06V361.571H367.977V249.328Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.263 274.471H183V279.859H286.263V274.471Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.06 272.675H285.366V282.552H288.06V272.675Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.422 260.212C301.479 259.428 302.367 258.302 303.204 258.332H352.731C353.543 258.31 354.46 259.251 354.485 260.086V287.263",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.422 260.212C301.479 259.428 302.367 258.302 303.204 258.332H352.731C353.543 258.31 354.46 259.251 354.485 260.086V287.263",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.487 262.798H306.018V278.961H319.487V262.798Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.394 260.704L301.408 287.138C301.368 287.946 302.297 289.008 303.148 289.032L352.051 289.029C353.223 289.06 354.134 288.673 354.483 287.321",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.394 260.704L301.408 287.138C301.368 287.946 302.297 289.008 303.148 289.032L352.051 289.029C353.223 289.06 354.134 288.673 354.483 287.321",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.793 268.185H308.712V269.083H316.793V268.185Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.793 269.981H308.712V272.675H316.793V269.981Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.017 262.798H326.671V278.961H350.017V262.798Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.528 266.389H331.161V274.47H345.528V266.389Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.544 498.058H554.748V499.854H556.544V498.058Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.075 498.058H542.177V499.854H543.075V498.058Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.217 498.058H567.319V499.854H568.217V498.058Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.009 744.098H563.644H553.009Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.009 744.098H563.644",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.231 740.525H566.78H550.231Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.231 740.525H566.78",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.2 721.716H567.216H549.2Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.2 721.716H567.216",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 719.532H567.295H549.238Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 719.532H567.295",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 724.415H567.333L561.154 729.698L555.137 729.672L549.238 724.415Z",
    fill: "white",
    fillOpacity: 0.39,
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 668.699H567.333H549.238Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.238 668.699H567.333",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.51 660.682H550.508H565.51Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.51 660.682H550.508",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.216 658.856H548.684H567.216Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.216 658.856H548.684",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.2 654.412H552.573H564.2Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.2 654.412H552.573",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.135 652.587H549.199H567.135Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.135 652.587H549.199",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.295 609.013H549.318H567.295Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.295 609.013H549.318",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.097 606.276H549.398H567.097Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.097 606.276H549.398",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.918 548.912H548.941H566.918Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.918 548.912H548.941",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.72 546.175H549.021H566.72Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.72 546.175H549.021",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.668 529.527H564.358H555.668Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.668 529.527H564.358",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.556 513.375H565.51H554.556Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.556 513.375H565.51",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.636 505.28H565.391H554.636Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.636 505.28H565.391",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.095 500.438H568.088H542.095Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.095 500.438H568.088",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.873 463.175H565.073H554.873Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.873 463.175H565.073",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.768 375.822H565.263H554.768Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.768 375.822H565.263",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.289 483.691H568.105C568.663 483.691 569.115 484.044 569.115 484.477V485.599C569.115 486.032 568.662 486.385 568.105 486.385H542.289C541.731 486.385 541.279 486.032 541.279 485.599V484.477C541.279 484.043 541.732 483.691 542.289 483.691Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.136 157.928L558.262 156.017L557.136 157.928Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.136 157.928L558.262 156.017",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.913 155.805L556.744 154.715L554.913 155.805Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.913 155.805L556.744 154.715",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.238 152.828H556.321H554.238Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.238 152.828H556.321",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.073 149.932L556.865 150.939L555.073 149.932Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.073 149.932L556.865 150.939",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.214 147.888L558.277 149.619L557.214 147.888Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.214 147.888L558.277 149.619",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.093 147.074V149.157V147.074Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.093 147.074V149.157",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.969 147.888L561.933 149.656L562.969 147.888Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.969 147.888L561.933 149.656",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.092 150.011L563.326 150.968L565.092 150.011Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.092 150.011L563.326 150.968",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.847 152.769H563.804H565.847Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.847 152.769H563.804",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.212 155.765L563.285 154.629L565.212 155.765Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.212 155.765L563.285 154.629",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.99 157.888L561.915 156.081L562.99 157.888Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.99 157.888L561.915 156.081",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.937 152.888C565.937 156.138 563.301 158.772 560.051 158.772C556.801 158.772 554.167 156.137 554.167 152.888C554.167 149.639 556.802 147.004 560.051 147.004C563.301 147.004 565.937 149.638 565.937 152.888Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.436 375.117H547.334H544.436Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.436 375.117H547.334",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.188 375.117H547.314H548.188Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.188 375.117H547.314",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.953 312.272L546.609 312.258L542.953 312.272Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.953 312.272L546.609 312.258",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.463 312.258H546.589H547.463Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.463 312.258H546.589",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.667 319.561V323.132V319.561Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.667 319.561V323.132",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.477 319.363V322.934V319.363Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.477 319.363V322.934",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.833 363.053H362.15H293.833Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.833 363.053H362.15",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.561 362.101H458.155H424.561Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.561 362.101H458.155",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.835 51.533H124.754V134.144H132.835V51.533Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.979 136.836H81.653V142.224H113.979V136.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.033 227.945C111.176 238.271 124.196 237.935 127.788 228.169L129.472 221.659",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.033 227.945C111.176 238.271 124.196 237.935 127.788 228.169L129.472 221.659",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.829 367.349H107.92L108.032 226.148L87.828 225.924L87.829 367.349Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.692 367.574L103.432 226.148H87.83V367.462L103.692 367.574Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.081 221.244H81.653V226.632H113.081V221.244Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.427 141.326H61V222.141H136.427V141.326Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.734 146.714H64.592V217.651H133.734V146.714Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.283 204.571C83.283 209.577 79.414 213.636 74.64 213.636C69.867 213.636 65.997 209.577 65.997 204.571C65.997 199.565 69.867 195.506 74.64 195.506C79.414 195.507 83.283 199.565 83.283 204.571Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.9864
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.242 204.609C101.24 209.637 97.369 213.711 92.596 213.709C87.826 213.707 83.959 209.634 83.957 204.609C83.957 199.581 87.827 195.506 92.6 195.506C97.373 195.507 101.242 199.583 101.242 204.609Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.9885
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.201 204.54C119.201 209.529 115.332 213.574 110.558 213.574C105.785 213.574 101.915 209.529 101.915 204.54C101.915 199.55 105.785 195.506 110.558 195.506C115.332 195.507 119.201 199.55 119.201 204.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.9847
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.942 204.971C79.942 207.716 77.717 209.941 74.971 209.941C72.226 209.941 70 207.715 70 204.971C70 202.225 72.226 200 74.971 200C77.717 199.999 79.942 202.225 79.942 204.971Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.907 204.486C97.907 207.231 95.682 209.456 92.936 209.456C90.191 209.456 87.965 207.23 87.965 204.486C87.965 201.74 90.191 199.515 92.936 199.515C95.682 199.514 97.907 201.74 97.907 204.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.866 204.486C115.865 207.231 113.639 209.455 110.893 209.454C108.149 209.453 105.926 207.229 105.924 204.486C105.924 201.74 108.15 199.515 110.895 199.515C113.641 199.514 115.866 201.74 115.866 204.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.4286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.184 152.101H130.142C131.133 152.101 131.938 152.906 131.938 153.897V190.713C131.938 191.704 131.133 192.509 130.142 192.509H68.184C67.192 192.509 66.388 191.704 66.388 190.713V153.897C66.388 152.906 67.191 152.101 68.184 152.101Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.142 155.693H69.98V188.917H130.142V155.693Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.856 134.142H135.529C136.52 134.142 137.325 134.947 137.325 135.938V139.53C137.325 140.522 136.52 141.326 135.529 141.326H123.856C122.864 141.326 122.06 140.522 122.06 139.53V135.938C122.06 134.947 122.864 134.142 123.856 134.142Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55 40.7571H133.734C135.718 40.7571 137.326 42.3651 137.326 44.3491V48.8391C137.326 50.8231 135.718 52.4311 133.734 52.4311H126.55C124.566 52.4311 122.958 50.8231 122.958 48.8391V44.3491C122.958 42.3651 124.566 40.7571 126.55 40.7571Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.568 45.551H81.263H122.568Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.568 45.551H81.263",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63 24V66.203V24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63 24V66.203",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.793 27.7041V62.7241V27.7041Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.793 27.7041V62.7241",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 32.249V58.402V32.249Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 32.249V58.402",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.176 37.6941V54.9241V37.6941Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.176 37.6941V54.9241",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.788 41.2849V49.7599V41.2849Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.788 41.2849V49.7599",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.447 43.0811V48.2441V43.0811Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.447 43.0811V48.2441",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_34445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsp);
export default __webpack_public_path__ + "static/media/esp.ffa23971785165328a6ad3e748aafa86.svg";
export { ForwardRef as ReactComponent };